import VALUES from 'core/data-model/constants/values'
import _ from 'lodash'
import Mustache from 'mustache'
import { getDisplayProducts } from 'quick-quote/product-selection/selectors'
import { createSelector } from 'reselect'
import messages from 'core/data-model/constants/messages'

export const getSelectedModelFactorID = (state) => state.coveragePlan.selectedModelFactorID

export const getBasicPlanErrorMessage = (state) => state.coveragePlan.selectedBasicPlan.error

const getBasicPlanOptionText = (product) => {
  const template = messages.BASIC_PLAN_SELECTION_LABEL
  if (!product.entryAge) {
    return product.code
  }
  return Mustache.render(template, {
    basicPlanCode: product.code,
    entryAgeMinimum: product.entryAge.minimum.value,
    entryAgeMaximum: product.entryAge.maximum.value,
  })
}

const getHealthDisplayProducts = createSelector(getDisplayProducts, (products) =>
  products.filter((p) => p.category === VALUES.HEALTH)
)

export const getBasicPlanOptions = createSelector(getHealthDisplayProducts, (products) =>
  products.map((p) => ({
    value: p.code,
    text: getBasicPlanOptionText(p),
  }))
)

export const getIhealthySelectedPlanName = (state) => _.get(state, 'coveragePlan.riders["MEH"].selectedPlan.plan', '')
export const getIhealthySelectedPlanCode = (state) =>
  _.get(state, 'coveragePlan.riders["MEH"].selectedPlan.planCode', '')
